import useRouter from "hooks/useRouter";
import EditDriverView from "../../components/EditDriverView";

EditDriverScreen.propTypes = {};

function EditDriverScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const driverId = router.query?.driverId;

    return (
        <div>
            <div className="my-4">
                <EditDriverView driverId={driverId} />
            </div>
        </div>
    );
}

export default EditDriverScreen;
